import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  addSearchStateValue,
  removeNavPop,
} from "../../../REDUX/NavbarDropDownToggle/navBarDropToggle";

const NavDropDownPop = ({
  /* content */
  areas,
  profileDropDownDetails,
}) => {
  const { accDropDownList, showStatePopUp } = useSelector(
    (state) => state.DropDownNav
  );
  const dispatch = useDispatch();
  // addSearchStateValue

  function AddSetState(e) {
    dispatch(addSearchStateValue(e.currentTarget.textContent));
    console.log(e.currentTarget.textContent);
  }
  /* Remove the two popUp on navbar */
  function removePop() {
    dispatch(removeNavPop());
  }
  return (
    <>
      <div
        onClick={removePop}
        className={`absolute w-60 border-2 border-[#CCE5FF] h-64 bg-[#F5FAFF] rounded transition duration-200 ease-in-out overflow-hidden
          ${showStatePopUp || accDropDownList ? "scale-100" : " scale-0"} 
          `}
      >
        {/* state list */}
        {showStatePopUp ? (
          <ul
            className=" overflow-y-scroll h-64 overflow-x-hidden no-scrollbar-white"
            // onClick={() => dispatch(toggleShowStatePopUp())}
          >
            {areas
              ? areas.map((state) => (
                  <Link>
                    <li
                      onClick={AddSetState}
                      key={state}
                      className="border-b-[5px] border-[#CCE5FF] py-2 text-lg  hover:bg-[#CCE5FF] md:my-0 hover:scale-105 hover:shadow-sm hover:font-bold  transition duration-700 ease-in-out"
                    >
                      <span className="mx-6  text-black font-workSans">
                        {state.name}
                      </span>
                    </li>
                  </Link>
                ))
              : null}
          </ul>
        ) : null}

        {/* prodile details */}
        {accDropDownList ? (
          <ul className=" overflow-y-scroll h-64 no-scrollbar">
            {profileDropDownDetails
              ? profileDropDownDetails.map((elem) => (
                  <Link
                    to={elem.url}
                    // onClick={() => dispatch(toggleAccDropDownList())}
                  >
                    <li
                      key={elem.text}
                      className="border-b-[5px] border-[#CCE5FF] py-2 text-lg  hover:bg-[#CCE5FF] md:my-0 hover:scale-105 hover:shadow-sm  hover:font-bold  transition duration-700 ease-in-out"
                    >
                      <span className="mx-6  text-black font-workSans capitalize">
                        {elem.text}
                      </span>
                    </li>
                  </Link>
                ))
              : null}
          </ul>
        ) : null}
      </div>
    </>
  );
};

export default NavDropDownPop;
/*   : accDropDownList && profileDropDownDetails
              ? 
                )) */
